<div class="aspect-auto flex min-h-screen max-h-screen justify-center items-center relative overflow-hidden"
    [class.submitting]="submitInProcess">
    <img [src]="'images/onboarding/onboard_orange.svg' | assetUrl" alt=""
        class="absolute top-[-4rem] left-[-4rem]  z-20">

    <img [src]="'images/onboarding/onboard_blue.svg' | assetUrl" alt=""
        class="absolute top-[-4rem] right-[-4rem] opacity-80">

    <img [src]="'images/onboarding/onboard_orange_bottom.svg' | assetUrl" alt="" class="absolute w-full bottom-0">
    @if(currentStep == 1) {
    <img [src]="'images/onboarding/onboard_step1_bottom.svg' | assetUrl" alt=""
        class="absolute bottom-0 z-20 w-full lg:max-h-[15rem] 2xl:max-h-[20rem]">
    }
    @if(currentStep == 2) {
    @if(teamInviteStep) {
    <img [src]="'images/onboarding/onboard_invite_left.svg' | assetUrl" alt=""
        class="absolute top-[25%] left-[10%] z-20 lg:max-h-[12rem] 2xl:max-h-[25rem]">
    <img [src]="'images/onboarding/onboard_invite_right.svg' | assetUrl" alt=""
        class="absolute bottom-[25%] right-4 z-20 lg:max-h-[12rem] 2xl:max-h-[25rem]">
    }
    @else {
    <img [src]="'images/onboarding/onboard_step2_left.svg' | assetUrl" alt=""
        class="absolute bottom-0 left-[-35%] z-20 w-full lg:max-h-[25rem] 2xl:max-h-[35rem]">
    <img [src]="'images/onboarding/onboard_step2_right.svg' | assetUrl" alt=""
        class="absolute bottom-0 right-[-35%] z-20 w-full lg:max-h-[25rem] 2xl:max-h-[35rem]">
    }
    }
    <div class="bg-white rounded-base z-50 shadow-lg shadow-arena-orange-200 max-h-[85vh] flex flex-col">
        <div class="sticky top-0 bg-white rounded-t-xl p-4 border-gray-100 z-10">
            <div class="flex flex-col gap-2">
                <span class="text-sm">{{getStepText() | textCase}}</span>
                <p-progressbar [value]="currentStep * 50">
                    <ng-template #content let-value>
                    </ng-template>
                </p-progressbar>
            </div>
        </div>
        @if(currentStep === 1) {
        <div class="flex-1 overflow-y-auto px-4 pb-4 lg:w-[50vw] 2xl:w-[40vw]">
            <div class="flex flex-col gap-2">
                <h2 class="text-2xl font-bold text-black">{{"Setup your profile" | textCase}}</h2>
                <form [formGroup]="profileForm" class="flex flex-col gap-4">
                    <div class="flex flex-row gap-4" (ngSubmit)="onSubmitProfile()">
                        <div class="relative">
                            <img [src]="profileForm.get('profilePicture')?.value" class="h-[5rem] w-[5rem] rounded-full"
                                alt="Profile">
                            @if(profileForm.get('profilePicture')?.value !== this.PROFILE_PICTURES().MALE &&
                            profileForm.get('profilePicture')?.value !== this.PROFILE_PICTURES().FEMALE) {
                            <div
                                class="absolute bottom-0 right-[5%] w-[22px] h-[22px] bg-black/50 rounded-full flex items-center justify-center cursor-pointer">
                                <i class="pi pi-times text-white !text-[10px]" (click)="removePicture()"></i>
                            </div>
                            }
                        </div>
                        <div class="flex flex-col gap-2">
                            <div class="text-sm font-bold text-black">{{"Profile Picture" | textCase}}</div>
                            <app-button label="{{getUploadPictureLabel() | textCase}}" icon="pi pi-upload"
                                (clicked)="fileInput.click()" variant="outlined" severity="contrast" />
                            <input #fileInput type="file" accept="image/jpeg,image/jpg,image/png,image/gif"
                                (change)="onFileSelect($event)" style="display: none;" />
                            <p class="text-xs text-gray-500 italic">
                                {{"You can setup your profile picture later in settings" | textCase}}</p>
                        </div>
                    </div>

                    <div class="flex flex-row gap-2 w-full">
                        <div class="form-field flex-1">
                            <label for="firstName">{{"First Name" | textCase}}<span class="text-danger">*</span></label>
                            <app-input id="firstName" formControlName="firstName" placeholder="{{'John' | textCase}}" />

                            @if( profileForm.controls['firstName'].errors &&
                            profileForm.controls['firstName'].touched){
                            <div class="text-danger"><small>*{{"First Name is Required" |
                                    textCase}}</small></div>
                            }
                        </div>

                        <div class="form-field flex-1">
                            <label for="lastName">{{"Last Name" | textCase}}<span class="text-danger">*</span></label>
                            <app-input id="lastName" formControlName="lastName" placeholder="{{'Smith' | textCase}}" />
                            @if( profileForm.controls['lastName'].errors &&
                            profileForm.controls['lastName'].touched){
                            <div class="text-danger"><small>{{"*Last Name is Required" |
                                    textCase}}</small></div>
                            }
                        </div>
                    </div>

                    <div class="flex">
                        <div class="form-field">
                            <label for="gender">{{"Gender" | textCase}}<span class="text-danger">*</span>
                                <i class="pi pi-info-circle ml-1 text-gray-500"
                                    pTooltip="This just helps us pick an avatar to start with, gender isn't a big deal here"
                                    tooltipPosition="right" style="font-size: 0.75rem;"></i>
                            </label>
                            <div class="flex gap-3 items-center justify-items-center">
                                <div class="flex items-center">
                                    <p-radioButton name="gender" value="MALE" formControlName="gender" inputId="male"
                                        (ngModelChange)="avatarValidator()" />
                                    <span for="male" class="ml-2 text-sm">
                                        {{"Male" | textCase}}
                                    </span>
                                </div>
                                <div class="flex items-center">
                                    <p-radioButton name="gender" value="FEMALE" formControlName="gender"
                                        (ngModelChange)="avatarValidator()" inputId="female" />
                                    <span for="female" class="ml-2 text-sm">
                                        {{"Female" | textCase}}
                                    </span>
                                </div>
                            </div>
                            @if( profileForm.controls['gender'].errors &&
                            profileForm.controls['gender'].touched){
                            <div class="text-danger"><small>{{"*Gender is Required" |
                                    textCase}}</small></div>
                            }
                        </div>
                    </div>

                    <div class="flex">
                        <div class="form-field flex-1">
                            <label for="email">{{"Email" | textCase}}<span class="text-danger">*</span></label>
                            <app-input id="email" formControlName="email" [readonly]="true"
                                placeholder="{{'John' | textCase}}" />

                            @if( profileForm.controls['email'].errors &&
                            profileForm.controls['email'].touched){
                            <div class="text-danger"><small>{{"*Email is Required" |
                                    textCase}}</small></div>
                            }
                        </div>
                    </div>

                    <div class="flex">
                        <div class="form-field flex-1">
                            <label for="username">{{"Username" | textCase}}<span class="text-danger">*</span></label>
                            <app-input id="username" formControlName="username" placeholder="{{'John' | textCase}}" />

                            @if( profileForm.controls['username'].errors &&
                            profileForm.controls['username'].touched &&
                            !profileForm.controls['username'].errors['alreadyExists']){
                            <div class="text-danger"><small>*{{"Username is Required" |
                                    textCase}}</small></div>
                            }
                            @if(profileForm.controls['username'].errors &&
                            profileForm.controls['username'].touched &&
                            profileForm.controls['username'].errors['alreadyExists']){
                            <div class="text-danger"><small>*{{"Username already exists" |
                                    textCase}}</small></div>
                            }
                        </div>
                    </div>

                    <div class="flex flex-row gap-2">
                        <div class="form-field flex-1">
                            <label for="password">{{"Password" | textCase}}<span class="text-danger">*</span></label>
                            <p-password id="password" class="border-1" class="w-full" formControlName="password"
                                [toggleMask]="true" appendTo="body" />
                            @if( profileForm.controls['password'].errors &&
                            profileForm.controls['password'].touched){
                            <div class="text-danger"><small>*{{"Password is Required" |
                                    textCase}}</small></div>
                            }
                        </div>
                        <div class="form-field flex-1">
                            <label for="confirmPassword">{{"Confirm Password" | textCase}}<span
                                    class="text-danger">*</span></label>
                            <p-password id="confirmPassword" class="border-1 " class="w-full"
                                formControlName="confirmPassword" [toggleMask]="true"
                                [disabled]="!profileForm.controls['password'].value" appendTo="body" />
                            @if(!profileForm.controls['confirmPassword'].valid &&
                            profileForm.controls['confirmPassword'].touched){
                            <div class="text-danger"><small>*{{"Confirm Password is Required" |
                                    textCase}}</small>
                            </div>
                            }

                            @if(profileForm.hasError('mismatch') && profileForm.touched){
                            <div class="text-danger">
                                <small>*{{"Passwords do not match." | textCase}}</small>
                            </div>
                            }
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="sticky bottom-0 bg-white rounded-b-xl p-4 border-gray-100">
            <div class="flex flex-col gap-2">
                <app-button type="submit" variant="filled" severity="primary" [disabled]="!profileForm.valid"
                    (clicked)="onSubmitProfile()" [fullWidth]="true" label="{{'Continue' | textCase}}" />
                <app-button type="button" variant="outlined" severity="contrast" (clicked)="clearProfile()"
                    [fullWidth]="true" label="{{'Cancel' | textCase}}" />
            </div>
        </div>
        }
        @if(currentStep === 2){
        @if(!teamInviteStep) {
        <div #scrollContainer class="flex-1 overflow-y-auto px-4 pb-4 lg:w-[50vw] 2xl:w-[40vw]">
            <div class="flex flex-col gap-4">
                <div class="flex gap-2 items-center">
                    <span class="pi pi-chevron-left cursor-pointer" (click)="previousStep()"></span>
                    <h2 class="text-2xl font-bold text-black">{{"Organization Setup" | textCase}}</h2>
                </div>
                <form [formGroup]="organizationForm" (ngSubmit)="onSubmitOrganization()" class="flex flex-col gap-4">
                    <div class="form-field ">
                        <label for="companyName ">{{"Company Name" | textCase}}<span
                                class="text-danger">*</span></label>
                        <app-input id="companyName" formControlName="companyName" (input)="onCompanyNameChange($event)"
                            placeholder="{{'Your Company' | textCase}}" />
                        @if( organizationForm.controls['companyName'].errors &&
                        organizationForm.controls['companyName'].touched){
                        <div class="text-danger ml-1"><small>*{{"Company Name is Required" | textCase}}</small>
                        </div>
                        }
                    </div>
                    <div class="form-field ">
                        <label for="companyEmail">{{"Company Email" | textCase}}<span
                                class="text-danger">*</span></label>
                        <app-input type="email" formControlName="companyEmail"
                            placeholder="{{'Info@yourcompanyemail.com' | textCase}}" />

                        @if( organizationForm.controls['companyEmail'].errors &&
                        organizationForm.controls['companyEmail'].touched){
                        <div class="text-danger ml-1"><small>*{{"Company Email is Required" | textCase}}</small>
                        </div>
                        }
                    </div>

                    <div class="form-field ">
                        <label for="companyDomain">{{"Company Domain" | textCase}}<span
                                class="text-danger">*</span></label>
                        <app-input type="text" formControlName="domain" id="domain"
                            placeholder="{{'https://www.yourcompany.com'}}" [readonly]="true" />

                        @if(organizationForm.controls['domain'].errors &&
                        organizationForm.controls['domain'].touched){
                        @if(organizationForm.controls['domain'].errors['required']){
                        <div class="text-danger ml-1"><small>*{{"Company Domain is Required" | textCase}}</small>
                        </div>
                        }
                        @if(organizationForm.controls['domain'].errors['invalidDomain']){
                        <div class="text-danger ml-1"><small>*
                                {{"Please enter a valid domain in format https://{domain}"}}</small>
                        </div>
                        }

                        @if(organizationForm.controls['domain'].errors &&
                        organizationForm.controls['domain'].touched &&
                        organizationForm.controls['domain'].errors['alreadyExists']){
                        <div class="text-danger ml-1"><small>*{{"Domain already exists" | textCase}}</small>
                        </div>
                        }
                        }
                    </div>

                    <div class="form-field">
                        <label class="font-bold text-base mb-2">People Login</label>
                        <div class="flex flex-col gap-2">
                            @for(method of loginMethods; track method.value){
                            <div class="flex items-center justify-between p-2 border rounded-base bg-white">
                                <div class="flex items-center gap-3 flex-1">
                                    @if(method.icon){
                                    <img [src]="method.icon" alt="{{method.label}}" class="w-4 h-4">
                                    }
                                    <span class="text-sm">{{method.label}}</span>
                                </div>
                                <app-toggle [(ngModel)]="method.enabled" [ngModelOptions]="{standalone: true}"
                                    (onChange)="onLoginMethodToggle(method, $event)">
                                </app-toggle>
                            </div>
                            }
                        </div>
                    </div>

                    @if(!additionalInformation){
                    <div class="input-field px-4 flex items-center justify-between"
                        [class.cursor-pointer]=" isCompanyInfoValid" [class.cursor-not-allowed]="!isCompanyInfoValid"
                        [class.disabled-section]="!isCompanyInfoValid" (click)="toggleAdditionalInformation()">
                        <div>{{"Additional information (optional)" | textCase}}</div>
                        <div class="pi pi-chevron-down cursor-pointer"></div>
                    </div>
                    }

                    @else{
                    <div #additionalInfoSection class="flex flex-col gap-4 additional-information">
                        <div class="flex items-center justify-between" (click)="toggleAdditionalInformation()">
                            <div class="text-sm text-gray-600 font-semibold">{{"Additional information (optional)" |
                                textCase}}</div>
                            <div class="pi pi-chevron-up cursor-pointer"></div>
                        </div>
                        <div class="flex gap-2 w-full">
                            <div class="form-field flex-1">
                                <label for="companySize">{{"Size (Employee Numbers)" | textCase}}</label>
                                <!-- <p-select [options]="noOfEmployees" formControlName="companySize"
                                    class="border w-full h-10 border-gray-200" placeholder="Company Size" /> -->

                                <app-select [options]="noOfEmployees" [config]="companySizeConfig"
                                    formControlName="companySize" />
                            </div>
                            <div class="form-field flex-1">
                                <label for="contact">{{"Phone" | textCase}}</label>
                                <app-phone-input formControlName="contact" appendTo="body"></app-phone-input>
                                <div *ngIf="organizationForm.controls['contact'].errors && organizationForm.controls['contact'].touched"
                                    class="text-danger text-xs mt-1">
                                    <small *ngIf="organizationForm.controls['contact'].errors?.['invalidNumber']">
                                        {{"*Please enter a valid phone number" | titlecase}}
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div class="form-field">
                            <label for="address">{{"Address" | textCase}}</label>
                            <textarea rows="3" cols="50" id="address" formControlName="address"
                                class="p-2 rounded-base border border-gray-300 focus:border-orange-500 focus:ring-orange-500 focus:outline-none w-full">
                                </textarea>
                        </div>
                    </div>

                    }
                </form>
            </div>
        </div>

        <div class="sticky bottom-0 bg-white rounded-b-xl p-4 border-gray-100">
            <div class="flex flex-col gap-2">
                <app-button type="submit" variant="filled" severity="primary" [disabled]="!isOrganizationFormValid"
                    (clicked)="onSubmitOrganization()" [loading]="submitInProcess" [fullWidth]="true"
                    [label]="'Complete Setup'" />
                <app-button type="button" variant="outlined" severity="contrast" [disabled]="!isOrganizationFormValid"
                    (clicked)="toggleTeamInviteStep()" [fullWidth]="true" [label]="'Add team members'" />
                <app-button type="button" variant="outlined" severity="contrast" (clicked)="previousStep()"
                    [fullWidth]="true" [label]="'Cancel'" />
            </div>
        </div>
        } @else {
        <div class="flex-1 overflow-y-auto px-4 pb-4 lg:w-[50vw] 2xl:w-[40vw]">
            <div class="flex flex-col gap-4">
                <div class="flex gap-2 items-center">
                    <span class="pi pi-chevron-left cursor-pointer" (click)="toggleTeamInviteStep()"></span>
                    <h2 class="text-2xl font-bold text-black">{{"Invite your team members" | textCase}}</h2>
                </div>
                <div class="flex justify-end">
                    <app-button label="{{'Add Member' | textCase}}" icon="pi pi-plus" variant="filled"
                        severity="primary" (clicked)="addMember()" [disabled]="members.length >= 6" />
                </div>
                <div class="flex flex-col gap-2">
                    @for (item of members; track $index) {
                    <div class="flex flex-col w-full gap-2">
                        <div class="flex w-full gap-2">
                            <div class="form-field flex-[2]">
                                <app-input type="email" [(ngModel)]="item.email" (input)="onEmailInput($index)"
                                    (blur)="onEmailInput($index)" [class]="item.emailExists ? 'border-red-500' : ''"
                                    placeholder="{{'somename@yourcompany.com' | textCase:CASE_TYPE.LOWER}}" />
                            </div>
                            <div class="flex flex-1 items-center gap-2">
                                <app-select [options]="userRoles" [config]="userRoleConfig" [(value)]="item.role"
                                    (valueChange)="onRoleChange($index)"
                                    [class]="hasRoleError(item.email, item.role, $index) ? 'border-red-500' : ''"
                                    class="w-full" />
                                <div class="min-w-10">
                                    <app-button variant="outlined" severity="danger" icon="pi pi-trash"
                                        (clicked)="removeMember($event, $index)" />
                                </div>
                            </div>
                        </div>
                        @if(hasEmailError(item.email, $index)) {
                        <div class="text-danger text-sm ml-1">
                            <small>*{{"Please enter a valid email address" | textCase}}</small>
                        </div>
                        }
                        @if(hasDuplicateEmail(item.email, $index)) {
                        <div class="text-danger text-sm ml-1">
                            <small>*{{"This email is already used by another team member" | textCase}}</small>
                        </div>
                        }
                        @if(item.emailExists) {
                        <div class="text-danger text-sm ml-1">
                            <small>*{{"This email is already registered" | textCase}}</small>
                        </div>
                        }
                        @if(hasRoleError(item.email, item.role, $index)) {
                        <div class="text-danger text-sm ml-1">
                            <small>*{{"Please select a role" | textCase}}</small>
                        </div>
                        }
                    </div>
                    }
                </div>
            </div>
        </div>

        <div class="sticky bottom-0 bg-white rounded-b-xl p-4 border-gray-100">
            <div class="flex flex-col gap-2">
                <app-button type="button" [disabled]="!areMembersValid" variant="filled" severity="primary"
                    (clicked)="onSubmitTeam()" [fullWidth]="true" [label]="'Send Invite'" />
                <app-button type="button" variant="outlined" severity="contrast" (clicked)="cancelTeamInviteStep()"
                    [fullWidth]="true" [label]="'Cancel'" />
            </div>
        </div>
        }
        }
    </div>
</div>
